<p>org-details-view works!</p>
